require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-susanne-wettstein.json") })
        }
      }, "path---en-interviste-susanne-wettstein");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-susanne-wettstein!./.cache/json/en-interviste-susanne-wettstein.json
// module id = 599
// module chunks = 231608221292675